<template>
    <re-b-modal ref="viewImg" clean centered max-height max-width>
        <b-img fluid fluid-grow :src="_generateDownloadUrl(images[currentIndex])"
               class="img-style"
               @click="cancelView"></b-img>

        <a href="#" role="button"
           class="carousel-control-prev"
           @click="switchImg(false)">
            <span aria-hidden="true" class="carousel-control-prev-icon"></span>
            <span class="sr-only">Previous slide</span>
        </a>
        <a href="#" role="button"
           class="carousel-control-next"
           @click="switchImg()">
            <span aria-hidden="true" class="carousel-control-next-icon"></span>
            <span class="sr-only">Next slide</span>
        </a>
    </re-b-modal>
</template>

<script>
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal.vue";
import {_generateDownloadUrl} from "@/components/LayoutMaps/openLayers/utils/MapUtils";

export default {
    name: "ViewImages",
    components: {ReBModal},
    data() {
        return {
            currentIndex: null,
            images: [],
        }
    },
    methods: {
        _generateDownloadUrl,

        view(id, list) {
            let index = list.indexOf(id);
            if (index >= 0) {
                this.currentIndex = index;
                this.images = list;
                this.$refs.viewImg.showModal();
            }
        },
        cancelView() {
            this.currentIndex = null;
            this.$refs.viewImg.hide();
        },
        switchImg(next = true) {
            if (next) {
                if (this.currentIndex === this.images.length - 1) {
                    this.currentIndex = 0;
                } else {
                    this.currentIndex++;
                }
            } else {
                if (this.currentIndex === 0) {
                    this.currentIndex = this.images.length - 1;
                } else {
                    this.currentIndex--;
                }
            }
        },
    }
}
</script>

<style scoped>
.img-style {
    max-height: 100%;
    max-width: 100%;
    width: auto !important;
    height: auto !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
}
</style>
